import { StationUnit } from "@/models/stationUnit.js"




// Electric meter unit
export class ElectricMeter extends StationUnit {
	// Some passport key names (not all)
	static get passportKeys() {
		return Object.freeze({
			self: 'electric_meter',
			type: 'type',
			ip: 'ip',
			port: 'port',
			user: 'user',
			password:'password',
			manufacturerId: 'manufacturer_id',
			surveyPeriod: 'survey_period',
			surveyPeriodMultiplier: 'surveyPeriodMultiplier',
			surveyStartTime: 'survey_start_time',
			verificationDate: 'verification_date',
		})
	}

	// Some electric meter unit key names (not all)
	static get metricKeys() {
		return Object.freeze({
			model: 'model',
			fullActiveEnergy: 'full_active_energy',
			activeEnergyFullApPam: 'active_energy_full_ap_p_am',
			lastConnection: 'last_connection',
			isConnect: 'is_connection',
		})
	}

	// Electric meter unit versions
	static get versions() {
		return Object.freeze({
			unknown: 'unknown',
			impulseInput: 'impulse_input',
			nikDlms: 'nik_dlms',
			gama100G1m: 'gama100_g1m',
			gama100G1b: 'gama100_g1b',
		})
	}

	// Electric meter unit version titles
	static get versionNames() {
		return Object.freeze({
			[ElectricMeter.versions.unknown]: 'Не визначений',
			[ElectricMeter.versions.impulseInput]: 'Імпульсний вхід',
			[ElectricMeter.versions.nikDlms]: 'NIK/DLMS',
			[ElectricMeter.versions.gama100G1m]: 'Gama100 G1M',
			[ElectricMeter.versions.gama100G1b]: 'Gama100 G1B',
		})
	}

	// Unit setting names for interface
	static get settingNames() {
		return Object.freeze({
			[ElectricMeter.passportKeys.type]: 'Тип',
			[ElectricMeter.passportKeys.ip]: 'IP адреса',
			[ElectricMeter.passportKeys.port]: 'Порт',
			[ElectricMeter.passportKeys.user]: 'Тип користувача',
			[ElectricMeter.passportKeys.password]: 'Пароль',
			[ElectricMeter.passportKeys.manufacturerId]: 'Заводський номер',
			[ElectricMeter.passportKeys.surveyPeriod]: 'Період опитування',
			[ElectricMeter.passportKeys.surveyPeriodMultiplier]: '',
			[ElectricMeter.passportKeys.surveyStartTime]: 'Час початку опитування',
			[ElectricMeter.passportKeys.verificationDate]: 'Дата останьої повірки',
		})
	}

	get passport() {
		return this._passport.get(ElectricMeter.passportKeys.self)
	}

	// Return true if unit version is not unknown
	get isPresent() {
		if (!this.passport 
			|| !this.passport[ElectricMeter.passportKeys.type]
			|| this.passport[ElectricMeter.passportKeys.type] == ElectricMeter.versions.unknown
		) {
			return false
		} else {
			return true
		}
	}

	// Return unit connection metric
	get isConnect() {
		// If meter type is undefine
		if (!this._passport.get(ElectricMeter.passportKeys.self) ||
			this._passport.get(ElectricMeter.passportKeys.self)[ElectricMeter.passportKeys.type] == undefined
		) {
			return true
		}

		const meterType = this._passport.get(ElectricMeter.passportKeys.self)[ElectricMeter.passportKeys.type]
		switch(meterType) {
			// Meter type is impulse imput of service unit
			case ElectricMeter.versions.impulseInput:
				return false
			// Meter type is nik dlms or gama100
			case ElectricMeter.versions.nikDlms:
			case ElectricMeter.versions.gama100G1m:
			case ElectricMeter.versions.gama100G1b:
				if (this.metrics.has(ElectricMeter.metricKeys.isConnect)) {
					return this.metrics.get(ElectricMeter.metricKeys.isConnect).value
				} else {
					return false
				}
			case ElectricMeter.versions.unknown:
				return true
			default:
				return false
		}
	}

	get isPresentActiveEnergyTarifs() {
		const en = [
			Number(this.getMetricValue(`${ElectricMeter.metricKeys.activeEnergyFullApPam}_1`)),
			Number(this.getMetricValue(`${ElectricMeter.metricKeys.activeEnergyFullApPam}_2`)),
			Number(this.getMetricValue(`${ElectricMeter.metricKeys.activeEnergyFullApPam}_3`)),
			Number(this.getMetricValue(`${ElectricMeter.metricKeys.activeEnergyFullApPam}_4`)),
		]
		// console.log('energy', en)
		return en.some((el) => el != 0)
	}
}